import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiUser } from '@wix/da-papi-types';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedInAndVerified } from '@wix/da-shared-react/pkg/utils/hooks/useRestrictToLoggedInAndVerified';

export interface Props {
  className?: string;
  user: PapiUser;
  startChat: () => void;
}
export const WatchButton: React.FC<Props> = ({ className, startChat }) => {
  const { restrictToLoggedInAndVerified } = useRestrictToLoggedInAndVerified();
  const { t } = useTranslation();
  return (
    <GhostButton
      size="medium"
      className={className}
      variant="main"
      onClick={restrictToLoggedInAndVerified(
        ReferralType.CHAT,
        'chat',
        startChat
      )}
    >
      {t(`common.chat`)}
    </GhostButton>
  );
};

export default WatchButton;
